export * from './sharePropTypes'

export const SHARE_OPTIONS = {
  COPY: 'copy',
  FACEBOOK: 'facebook',
  MESSENGER: 'messenger',
  LINKEDIN: 'linkedin',
  TWITTER: 'twitter',
  EMAIL: 'email',
  MESSAGE: 'message',
  MORE: 'more',
} as const

export const SOURCES = {
  ARTICLES: 'articles',
  CATALOG: 'catalog',
  CLASS: 'class',
  CLASS_GUEST: 'class_guest',
  CLASS_GUEST_NEXT: 'class_guest_next',
  CLASS_LOCKED: 'class_locked',
  EPISODE_PAGE: 'episode_page',
  LESSON: 'lesson',
  LESSON_TILE: 'lesson_tile',
  LESSON_VIDEO: 'lesson_video',
  LESSON_PAGE_LOGGED_OUT: 'lesson_page_logged_out',
  SINGLE_CLASS_GIFT: 'single_class_gift',
  HOMEPAGE_CLASS_SAMPLES: 'homepage_class_samples',
  HOMEPAGE_FEATURED_INSTRUCTOR: 'homepage_featured_instructor',
  HOMEPAGE_FEATURED_INSTRUCTOR_NEXT: 'homepage_featured_instructor_next',
  IMMERSIVE_HERO: 'immersive_hero',
  RECIPES: 'recipes',
} as const
